import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchUser } from '@/store/slices/authSlice'

export const useAuth = () => {
  const dispatch = useDispatch()
  const { user, isAuthenticated, loading, token } = useSelector((state) => state.auth)

  useEffect(() => {
    // If we have a token but no user data, fetch the user
    if (token && !user && !loading) {
      dispatch(fetchUser())
    }
  }, [token, user, loading, dispatch])

  return {
    user,
    isAuthenticated,
    loading: loading || (token && !user), // Loading if we have token but no user yet
  }
}